import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FollowupsTypes } from 'store/modules/market_store/types';
import moment from 'moment';
import colors from 'styles/colors';
import { linkDaLicitacao } from 'services/market_links';

interface FollowupstModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  followups: FollowupsTypes;
}

const FollowupstModal = (props: FollowupstModalProps) => {
  const { showModal, setShowModal, followups } = props;

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">Acompanhamentos</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="px-3">
              <div className="row mt-4">
                <div className="col-md-12">
                  <span className="font-weight-bold">Objeto</span>
                  <p>{followups?.licitacao?.objeto}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-4">
                  <span className="font-weight-bold">Data</span>
                  <p>{moment.parseZone(followups?.licitacao?.data_validade).format('L')}</p>
                </div>
                <div className="col-md-4">
                  <p>
                    <b>Nº ConLicitação</b> <br />
                    <a
                      href={linkDaLicitacao(followups?.licitacao?.id)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {followups?.licitacao?.id}
                    </a>
                  </p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">Situação</span>
                  <p>{followups?.licitacao?.tipo_agrupamento_descricao}</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="px-3">
              <div className="row">
                <div className="col-md-4">
                  <span className="font-weight-bold">Órgão</span>
                  <p>{followups?.licitacao?.orgao?.nome}</p>
                </div>
                <div className="col-md-8">
                  <span className="font-weight-bold">Processo</span>
                  <p>{followups?.licitacao?.orgao?.uasg}</p>
                </div>
              </div>
            </div>
            <div className="px-3">
              <div className="row">
                <div className="col-md-8">
                  <span className="font-weight-bold">Órgão</span>
                  <p>
                    {followups?.licitacao?.orgao?.cidade}/{followups?.licitacao?.orgao?.estado}
                  </p>
                </div>
                <div className="col-md-4">
                  <span className="font-weight-bold">UASG</span>
                  <p>{followups?.licitacao?.orgao?.endereco}</p>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-md-12">
              <div className="card shadow">
                <div className="table-responsive" style={{ maxHeight: '360px' }}>
                  <table className="table table-hover w-auto mb-0 table-bordered">
                    <thead style={{ backgroundColor: '#EBECEF' }}>
                      <tr>
                        <th scope="col">Síntese</th>
                        <th scope="col">Data da Fonte</th>
                      </tr>
                    </thead>
                    <tbody>
                      {followups?.licitacao?.acompanhamentos?.map((acomp: any) => (
                        <tr key={acomp?.id}>
                          <td>{acomp?.sintese}</td>
                          <td>{moment.parseZone(acomp?.data_fonte).format('L')}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={() => setShowModal(false)}
              >
                fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FollowupstModal;
